import { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export interface SearchParams {
  [key: string]: string | number | undefined | null;
}

type UseSearchParamsResult = [
  URLSearchParams,
  (newParams: SearchParams) => void,
  (retainedParams: SearchParams) => void,
];

const useSearchParams = (): UseSearchParamsResult => {
  const history = useHistory();
  const location = useLocation();
  const [searchParams, setSearchParams] = useState<URLSearchParams>(
    new URLSearchParams(location.search)
  );

  useEffect(() => {
    setSearchParams(new URLSearchParams(location.search));
  }, [location.search]);

  const updateSearchParams = (newParams: SearchParams) => {
    const updatedSearchParams = new URLSearchParams(searchParams);

    Object.keys(newParams).forEach((key) => {
      const value = newParams[key];
      if (value === undefined || value === null) {
        updatedSearchParams.delete(key);
      } else {
        updatedSearchParams.set(key, value.toString());
      }
    });

    history.replace({
      search: updatedSearchParams.toString(),
    });
  };

  const clearSearchParams = (retainedParams: SearchParams) => {
    const updatedSearchParams = new URLSearchParams();
    Object.keys(retainedParams).forEach((key) => {
      const value = retainedParams[key];
      if (value !== undefined && value !== null) {
        updatedSearchParams.set(key, value.toString());
      }
    });

    history.replace({
      search: updatedSearchParams.toString(),
    });
  };

  return [searchParams, updateSearchParams, clearSearchParams];
};

export default useSearchParams;
